
import {defineComponent} from 'vue';
import Tooltip from "@/components/Tooltip.vue";
import IconBase from "@/components/IconBase.vue";
import ServerError from "@/components/ServerError.vue";
import Button from "@/components/ergebnis/Button.vue";
import ErgebnisKompTO from "@/types/ErgebnisKompTO";
import {aufrundenAufGanzzahl} from "@/utils/NumberUtil";
import numberMixin from "@/mixins/NumberMixin";

export default defineComponent({
    name: 'Ergebnis',
    components: {Tooltip, IconBase, ServerError, Button},
    mixins: [numberMixin],
    data() {
        return {
            gesamteffektivzins: 0.0,
            gesamtlaufzeit: "",
            monatlicheRate: 0.0,

            textGesamtzeffektivzins: "",
            textMonatlicheRate: "",
            textMoeglicheGesamtlaufzeit: "",
            textButtonBeratung: "",
            textErrorHeading: "Anwendung nicht verfügbar",
            textErrorMessage: "Aufgrund technischer Wartungsarbeiten ist die Anwendung derzeit nicht verfügbar.",
            textTooltipGesamteffektivzins: "",
            urlKontaktformular: ""
        };
    },
    props: {
        showServerError: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        onButtonClicked(): void {
            let parameter = ' rechnerTyp: baudarlehen; kaufpreis: ' + this.convertNumberWithTwoDigitsAndSuffixEuroIso(this.kaufpreis) + ';'
                + ' darlehensbetrag: ' + this.convertNumberWithTwoDigitsAndSuffixEuroIso(this.darlehensbetrag) + ';'
                + ' sollzinsbindung: ' + this.sollzinsbindung + ' Jahre;'
                + ' rate: ' + this.convertNumberWithTwoDigitsAndSuffixEuroIso(this.monatlicheRate) + ';'

            window.location.href = this.urlKontaktformular + parameter;
        },
        animateNumbers(): void {
            if (this.isCalculating) {
                this.gesamteffektivzins = parseFloat(this.getRandomNumbers(this.gesamteffektivzins.toString()));
                this.monatlicheRate = parseFloat(this.getRandomNumbers(this.monatlicheRate.toString()));
                this.gesamtlaufzeit = this.getRandomNumbers(this.gesamtlaufzeit);
                requestAnimationFrame(this.animateNumbers)
            } else {
                this.gesamteffektivzins = this.ergebnis.gesamteffektivzins;
                this.monatlicheRate = aufrundenAufGanzzahl(this.ergebnis.monatlicheRate, 1);
                this.gesamtlaufzeit = this.getGesamtlaufzeit();
            }
        },
        //Die Zahlen im String sollen animiert werden, der Text nicht
        getRandomNumbers(text: string): string {
            let regex = /\d/gi,
                result,
                stringSplitted = text.split('');
            while ((result = regex.exec(text))) {
                let randomDigit = Math.floor(Math.random() * 9) + 1
                stringSplitted[result.index] = randomDigit.toString();
            }
            return stringSplitted.join('');
        },
        getGesamtlaufzeit(): string {
            const anzahlJahre = this.ergebnis.moeglicheGesamtlaufzeit.jahre;
            const anzahlMonate = this.ergebnis.moeglicheGesamtlaufzeit.monate;
            return anzahlJahre + (anzahlJahre > 1 ? " Jahre " : " Jahr ") + anzahlMonate + (anzahlMonate > 1 ? " Monate" : " Monat");
        },
    },
    computed: {
        //Lesen der Werte aus dem Store
        ergebnis(): ErgebnisKompTO {
            return this.$store.state.berechnungsergebnis.ergebnisWidgetTO;
        },
        isCalculating(): boolean {
            return this.$store.state.isCalculating;
        },
        kaufpreis(): number {
            return parseFloat(this.$store.state.sliderPreis.value);
        },
        darlehensbetrag(): number {
            return parseFloat(this.$store.state.sliderDarlehen.value);
        },
        sollzinsbindung(): number {
            return this.$store.state.selectedSollzinsbindung;
        },
        isInitDataLoaded(): boolean {
            return this.$store.state.initDataLoaded;
        },
    },
    watch: {
        isCalculating: function (newVal) {
            if (newVal) {
                this.animateNumbers();
            }
        },
        isInitDataLoaded(isLoaded: boolean): void {
            if (isLoaded) {
                this.textGesamtzeffektivzins = this.$store.state.fachtexte["rechner.ergebnis.gesamteffektivzins"];
                this.textMonatlicheRate = this.$store.state.fachtexte["rechner.ergebnis.monatliche.rate"];
                this.textMoeglicheGesamtlaufzeit = this.$store.state.fachtexte["rechner.ergebnis.laufzeit"];
                this.textButtonBeratung = this.$store.state.fachtexte["rechner.ergebnis.beratungsbutton"];
                this.textErrorHeading = this.$store.state.fachtexte["rechner.ergebis.fehler.ueberschrift"];
                this.textErrorMessage = this.$store.state.fachtexte["rechner.ergebnis.fehlertext"];
                this.textTooltipGesamteffektivzins = this.$store.state.fachtexte["rechner.ergebnis.tooltip.gesamteffektivzins"];
                this.urlKontaktformular = this.$store.state.fachtexte["url.beratungsformular"];
            }
        }
    },
    mounted() {
        this.animateNumbers();
    }
});
